import { ArrowDownward, ArrowUpward, Delete } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useTranslation } from 'next-i18next';
import React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { SpeakerEntry } from '../../../../../interfaces/pagebuilder';
import { SpeakerSelectInput } from './SpeakerSelectInput';

interface SpeakerSelectProps {
  availableSpeakers?: SpeakerEntry[];
  watchSpeakers?: any;
}

export const SpeakerSelect = (props: SpeakerSelectProps) => {
  const { availableSpeakers = [], watchSpeakers } = props;

  const { t } = useTranslation();

  const { control, watch } = useFormContext();
  const { fields: speakers, append, remove, swap } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormContext)
    name: 'speakers', // unique name for your Field Array
  });

  const watchSpeaker = watchSpeakers ?? watch('speakers', []);

  const watchSpeakerIds = watchSpeaker?.map((speaker: SpeakerEntry) => speaker._id);
  const filteredSpeakers = availableSpeakers?.filter((speaker) => !watchSpeakerIds || !watchSpeakerIds.includes(speaker._id));
  return (
    <>
      <div className="flex flex-col">
        {availableSpeakers && availableSpeakers?.length > 0 && t('pagebuilder:speakers')}
        <SpeakerSelectInput availableSpeakers={filteredSpeakers} onSubmit={(data) => append(data)} />
        {speakers
          ?.filter((sp: any) => !!availableSpeakers.find((asp) => asp._id === sp._id))
          .map((field: any, index) => (
            <div key={field.key}>
              <div>{field.name}</div>
              <Button disabled={watchSpeaker.length < 2 || index === watchSpeaker.length - 1} onClick={() => swap(index, index + 1)}>
                <ArrowDownward />
              </Button>
              <Button disabled={watchSpeaker.length < 2 || index === 0} onClick={() => swap(index, index - 1)}>
                <ArrowUpward />
              </Button>
              <Button onClick={() => remove(index)}>
                <Delete />
              </Button>
            </div>
          ))}
      </div>
    </>
  );
};
